import styled from 'styled-components';
interface IProps {
  hideBackButton?: boolean;
}

export const CustomFullscreenBarStyled = styled.div<IProps>`
  width: 100%;
  .Polaris-FullscreenBar__BackAction {
    display: ${(props) => (props.hideBackButton ? 'none' : 'flex')};
  }
  .fullscreen-bar__content {
    display: flex;
    flex-grow: 1;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    @media (max-width: 576px) {
      padding: 0;
      .Polaris-Tabs__ButtonWrapper {
        justify-content: center;
      }
    }
  }
`;
